// extracted by mini-css-extract-plugin
export var editButton = "_ow-0";